import styled from 'styled-components';
import { Colors, Fonts } from 'styles/constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: -8px 0 16px;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const ToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 0 16px;
  border: 1px solid ${Colors.Orange};
  border-radius: 6px;
  background: ${Colors.Orange};
  color: ${Colors.White};
  font-family: ${Fonts.GilroyBold};
  font-size: 13px;
  cursor: pointer;

  &:hover {
    filter: brightness(0.96);
  }
`;

export const ActiveCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: ${Colors.White};
  color: ${Colors.Orange};
  font-size: 11px;
`;

export const FilterPanel = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px;
  border: 1px solid ${Colors.Gray20};
  border-radius: 8px;
  background: ${Colors.White};
  font-family: ${Fonts.GilroyRegular};

  input {
    font-family: ${Fonts.GilroyRegular};
  }
`;

export const StatusGroup = styled.fieldset`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 18px;
  margin: 0;
  padding: 0 0 16px;
  border: 0;
  border-bottom: 1px solid ${Colors.Gray20};
`;

export const StatusLegend = styled.legend`
  width: 100%;
  margin-bottom: 4px;
  color: ${Colors.Gray70};
  font-family: ${Fonts.GilroyBold};
  font-size: 12px;
`;

export const StatusOption = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: ${Colors.Gray70};
  font-family: ${Fonts.GilroyRegular};
  font-size: 14px;
  cursor: pointer;

  input {
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
  }
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px 16px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const Field = styled.div<{ $wide?: boolean }>`
  min-width: 0;
  ${({ $wide }) => $wide && 'grid-column: span 2;'}

  label {
    font-family: ${Fonts.GilroySemiBold};
  }

  @media (max-width: 640px) {
    grid-column: span 1;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 14px;
  border-top: 1px solid ${Colors.Gray20};

  button {
    min-height: 36px;
    padding: 0 16px;
    border: 1px solid ${Colors.Gray30};
    border-radius: 6px;
    background: ${Colors.White};
    color: ${Colors.Gray70};
    font-family: ${Fonts.GilroyBold};
    font-size: 12px;
    cursor: pointer;
  }

  button[type='submit'] {
    border-color: ${Colors.Orange};
    background: ${Colors.Orange};
    color: ${Colors.White};
  }
`;

export const DateError = styled.p`
  margin: -8px 0 0;
  color: ${Colors.Magenta};
  font-size: 12px;
`;
